// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"b647cb1c","401":"8ea6f935","424":"a0878c99","487":"796c1e0b","531":"d782aa19","549":"e6603612","761":"c2d97765","823":"e34b8ab0"}[chunkId] + ".chunk.js";
};